module.exports = __webpack_public_path__ + "img/example7.e569f65c.jpg";